import {
    StoreServiceData,
    ServiceActionTypes,
    createDefaultStoreState,
    createReducer
} from "store-fetch-wrappers/dist";
import {CREATE_DIRECTORY_STORE_STATE} from "../actions/CreateDirectoryActionTypes";
import {showErrorToast} from "../../../utils/toastUtils";

const defaultState = createDefaultStoreState<string>(null);

const createDirectoryReducer = (
    state: StoreServiceData<string> = defaultState,
    action: ServiceActionTypes<string>
): StoreServiceData<string> =>
    createReducer(state, action, CREATE_DIRECTORY_STORE_STATE, () => showErrorToast(action.error));

export default createDirectoryReducer;
